var _path, _path2, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCautionRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#FADB5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.714a7.714 7.714 0 1 0 0-15.429 7.714 7.714 0 0 0 0 15.429Z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.43c-4.726 0-8.57 3.845-8.57 8.57 0 4.726 3.845 8.572 8.571 8.572 4.726 0 8.572-3.846 8.572-8.572 0-4.726-3.846-8.571-8.572-8.571Zm0 15.428a6.865 6.865 0 0 1-6.857-6.857A6.865 6.865 0 0 1 12 5.144a6.865 6.865 0 0 1 6.857 6.857A6.865 6.865 0 0 1 12 18.858Zm0-6a.856.856 0 0 0 .857-.857V8.573a.856.856 0 1 0-1.714 0V12c0 .474.383.857.857.857Zm0 1.63a.943.943 0 1 0 0 1.885.943.943 0 0 0 0-1.886Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.43c-4.726 0-8.57 3.845-8.57 8.57 0 4.726 3.845 8.572 8.571 8.572 4.726 0 8.572-3.846 8.572-8.572 0-4.726-3.846-8.571-8.572-8.571Zm0 15.428a6.865 6.865 0 0 1-6.857-6.857A6.865 6.865 0 0 1 12 5.144a6.865 6.865 0 0 1 6.857 6.857A6.865 6.865 0 0 1 12 18.858Zm0-6a.856.856 0 0 0 .857-.857V8.573a.856.856 0 1 0-1.714 0V12c0 .474.383.857.857.857Zm0 1.63a.943.943 0 1 0 0 1.885.943.943 0 0 0 0-1.886Z",
    fill: "#B25900"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionRound);
export default __webpack_public_path__ + "static/media/caution-round.3d68661d.svg";
export { ForwardRef as ReactComponent };